export default __webpack_public_path__ + "static/media/ideas_3.80dc5fb1.PNG";